import React, { useState } from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  PageListBean,
  PurchaseReceiptForFabricStyleStatisticsBean,
  RestPageListBean,
  RestReadRequest,
  RestVendorListRequest,
  RestVendorPurchaseOnOrderListRequest,
  VendorOnOrderPrintRequest,
  VendorPurchaseOnOrderDetailsBean,
  VendorPurchaseOnOrderSearchCriteria,
  VendorSearchCriteria,
  VendorStatisticsInquiryCriteriaBean,
  VendorStatisticsPrintRequest,
  VendorSummaryOnOrderATSDetailsRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
  PopupSalesModule,
  PopupVendorModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import { ReportService } from "../services/ReportService.js";
import { VendorService } from "../services/VendorService.js";
import CustomTable from "../gui_components/CustomTable.js";
class VendorStatistics extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Vendor Statistics Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      isShowVendorQtyPopup: false,
      isShowVendorSummaryPopup: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new VendorStatisticsInquiryCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      isShowPurchaseOrderModule: false,
      isShowPurchaseReceiptModule: false,
      moduleForPopup: [],
      inquiryData: null,
      receiptList: [],
      orderInfoList: [],
      vendorLookupHandler: null,
      lastReceiptList: [],
      isShowLastReceiptDetailsPopup: false,
      showAutoCompleteList: true,
      vendorPageListForAutoCompleteList: new Array(),
      showAutoCompleteVendorList: true,
      fabricVendorInfoBean: new VendorPurchaseOnOrderDetailsBean(),
      vendorSummaryDataList: [],
      isDisableFields: false,
      sourceOrderDetailLines: [],
      vendorQtyDataList: [],
      is3PL: false,
    };
    this.vendorCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor"
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };

  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadVendorStatisticsInquiryList(criteria);
  };
  loadVendorStatisticsInquiryList = (criteria) => {
    if (SecurityAccessManager.VendorStatiticsInquiry_IsAccessible()) {
      ReportService.inquireVendorStatisticsData(
        criteria,
        this.loadVendorStatisticsPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadVendorStatisticsPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let receiptList = [];
      let orderInfoList = [];
      let inquiryData = response.data.result;
      if (!isEmptyArray(response.data.result.purchaseOrderReceipts)) {
        receiptList = response.data.result.purchaseOrderReceipts;
      }
      if (response.data.result.onOrderDetailBean != null) {
        if (
          !isEmptyArray(
            response.data.result.onOrderDetailBean.onOrderInfoDetails
          )
        ) {
          orderInfoList =
            response.data.result.onOrderDetailBean.onOrderInfoDetails;
        }
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        receiptList: receiptList,
        orderInfoList: orderInfoList,
        inquiryData: inquiryData,
        isShowPDFButton: true,
        isShowExcelButton: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new VendorStatisticsInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    this.setState({
      criteria: criteria,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
  };
  resetInquiry = () => {
    let criteria = new VendorStatisticsInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new VendorStatisticsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.VendorStatiticsInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateVendorStatisticsPrintReport(
          listRequest,
          this.generateVendorStatisticsPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.VendorStatiticsInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateVendorStatisticsPrintReport(
          listRequest,
          this.generateVendorStatisticsPageExcelResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateVendorStatisticsPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateVendorStatisticsPageExcelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
         let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
         window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  vendorOnOrderQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let fabricVendorInfoBean = new VendorPurchaseOnOrderDetailsBean();
      fabricVendorInfoBean.companyCode = this.companyCode;
      fabricVendorInfoBean.fabricStyleCode = rowData.fabricStyleCode;
      fabricVendorInfoBean.fabricStyleShortName = rowData.fabricStyleShortName;
      fabricVendorInfoBean.colorCode = rowData.colorCode;
      fabricVendorInfoBean.onOrderQuantity = rowData.onOrderQuantity;
      fabricVendorInfoBean.inTransitQuantity = rowData.inTransitQuantity;
      this.setState({ fabricVendorInfoBean: fabricVendorInfoBean });
      let vendorQtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
      vendorQtyCriteria.companyCode = this.companyCode;
      vendorQtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      vendorQtyCriteria.colorCode = rowData.colorCode;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestVendorPurchaseOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = vendorQtyCriteria;
      if (rowData.onOrderQuantity != 0) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Fetching VendorOn Order Details...",
        });
        this.loadVendorOnOrderQtyListPage(listRequest);
      } else {
        let errMsg = "No data found";
        let errList = [];
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  loadVendorOnOrderQtyListPage = (listRequest) => {
    VendorService.getVendorPurchaseOnOrderDetailsForFabricStyleStatistics(
      listRequest,
      this.loadPOFabricStatisticsResponse,
      this.errorCallBack
    );
  };
  loadPOFabricStatisticsResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      let vendorQtyDataList = new Array();
      let sourceOrderDetailLines = new Array();
      if (!isEmptyArray(response.data.orderDetailsResult.onOrderInfoDetails)) {
        vendorQtyDataList = response.data.orderDetailsResult.onOrderInfoDetails;
      }
      if (
        !isEmptyArray(response.data.orderDetailsResult.sourceOrderDetailLines)
      ) {
        sourceOrderDetailLines =
          response.data.orderDetailsResult.sourceOrderDetailLines;
      }
      this.setState({
        vendorQtyDataList: vendorQtyDataList,
        sourceOrderDetailLines: sourceOrderDetailLines,
        isShowVendorQtyPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateVendorOnOrderPdf = (e) => {
    if (e.detail === 1) this.generateVendorOnOrderReport(1);
  };
  generateVendorOnOrderExcel = (e) => {
    if (e.detail === 1) this.generateVendorOnOrderReport(2);
  };
  generateVendorOnOrderReport = (reportType) => {
    let fabricVendorInfoBean = this.state.fabricVendorInfoBean;
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricVendorInfoBean.fabricStyleCode;
    criteria.colorCode = fabricVendorInfoBean.colorCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;

    let listRequest = new VendorOnOrderPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    ReportService.generateVendorOnOrderPrintReport(
      listRequest,
      this.generateVendorOnOrderResponse,
      this.errorCallBack
    );
  };
  generateVendorOnOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  vendorSummaryOnClick = (e) => {
    if (e.detail === 1) {
      let fabricVendorInfoBean = this.state.fabricVendorInfoBean;
      let criteria = new VendorPurchaseOnOrderDetailsBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = fabricVendorInfoBean.fabricStyleCode;
      criteria.fabricStyleShortName = fabricVendorInfoBean.fabricStyleShortName;
      criteria.colorCode = fabricVendorInfoBean.colorCode;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestVendorPurchaseOnOrderListRequest();
      listRequest.searchCriteria = criteria;
      listRequest.pageInput = pageInput;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Fetching Vendor Summary...",
      });
      this.loadVendorOrderSummaryPage(listRequest);
    }
  };
  loadVendorOrderSummaryPage = (criteria) => {
    ReportService.getVendorSummaryOnOrderATSQuantities(
      criteria,
      this.loadVendorOrderSummaryPageResponse,
      this.errorCallBack
    );
  };
  loadVendorOrderSummaryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      if (response.data.orderDetailsResult.onOrderInfoDetails != null) {
        const vendorSummaryDataList =
          response.data.orderDetailsResult.onOrderInfoDetails;
        this.setState({
          vendorSummaryDataList: vendorSummaryDataList,
          isShowVendorSummaryPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  generateVendorSummaryPdf = (e) => {
    if (e.detail === 1) this.generateVendorSummaryReport(1);
  };
  generateVendorSummaryExcel = (e) => {
    if (e.detail === 1) this.generateVendorSummaryReport(2);
  };
  generateVendorSummaryReport = (reportType) => {
    let fabricVendorInfoBean = this.state.fabricVendorInfoBean;
    let criteria = new VendorPurchaseOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = fabricVendorInfoBean.fabricStyleCode;
    criteria.colorCode = fabricVendorInfoBean.colorCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new VendorSummaryOnOrderATSDetailsRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    ReportService.getVendorSummaryOnOrderATSDetailsReport(
      listRequest,
      this.generateVendorSummaryResponse,
      this.errorCallBack
    );
  };
  generateVendorSummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeAlertSummaryModalCallBack = (isShowPopup) => {
    this.setState({
      isShowVendorSummaryPopup: isShowPopup,
    });
  };
  viewPOModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPRModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      moduleForPopup: [],
    });
  };
  lastReceiptDetails = (e, val, month) => {
    if (e.detail === 1) {
      let vend_criteria = this.state.criteria;
      let criteria = new PurchaseReceiptForFabricStyleStatisticsBean();
      criteria.companyCode = this.companyCode;
      criteria.vendorCode = vend_criteria.vendorCode;
      if (val > 0) {
        if (month === 3) {
          PurchaseOrderReceiptService.getPurchaseOrderReceiptListForLast3MonthsSalesInvoiceForFabricStyleStatistics(
            criteria,
            this.loadMonthsReceiptPageResponse,
            this.errorCallBack
          );
        } else if (month === 6) {
          PurchaseOrderReceiptService.getPurchaseOrderReceiptListForLast6MonthsSalesInvoiceForFabricStyleStatistics(
            criteria,
            this.loadMonthsReceiptPageResponse,
            this.errorCallBack
          );
        } else if (month === 12) {
          PurchaseOrderReceiptService.getPurchaseOrderReceiptListForLast12MonthsSalesInvoiceForFabricStyleStatistics(
            criteria,
            this.loadMonthsReceiptPageResponse,
            this.errorCallBack
          );
        } else if (month === 18) {
          PurchaseOrderReceiptService.getPurchaseOrderReceiptListForLast18MonthsSalesInvoiceForFabricStyleStatistics(
            criteria,
            this.loadMonthsReceiptPageResponse,
            this.errorCallBack
          );
        } else if (month === 24) {
          PurchaseOrderReceiptService.getPurchaseOrderReceiptListForLast24MonthsSalesInvoiceForFabricStyleStatistics(
            criteria,
            this.loadMonthsReceiptPageResponse,
            this.errorCallBack
          );
        }
      }
    }
  };
  loadMonthsReceiptPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let lastReceiptList = [];
      if (!isEmptyArray(response.data.result.purchaseReceipts)) {
        lastReceiptList = response.data.result.purchaseReceipts;
        this.setState({
          lastReceiptList: lastReceiptList,
          isShowLastReceiptDetailsPopup: true,
        });
      }
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowLastReceiptDetailsPopup: isShowPopup,
      isShowVendorQtyPopup: isShowPopup,
    });
  };
  vendorCodeOnChange = (e) => {
    let vendorCode = e.target.value;
    this.state.showAutoCompleteVendorList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.showAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      let criteria = this.state.criteria;
      criteria.vendorCode = "";
      criteria.vendorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetVendorDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.vendor != null) {
      let vendorData = response.data.vendor;
      if (!isEmpty(vendorData)) {
        criteria.vendorName = vendorData.description;
        criteria.vendorCode = vendorData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetVendorDetail = (vendorCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = vendorCode;
    input.isLoadChildren = true;
    VendorService.readVendor(
      input,
      this.readandsetVendorDetailResponse,
      this.errorCallBack
    );
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.errorCallBack
    );
  }
  readByVendorCodeResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    let vendorCode = e.target.value;
    this.readandsetVendorDetail(vendorCode);
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteVendorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
  };
 
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item" : "Fabric",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)

    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "FabricStyle Name",
          "fabricStyleName",
          true
        )
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPOModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPRModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "receiptDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("RcdQty", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  onOrderDetailsColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)

    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "FabricStyle Name",
          "fabricStyleShortName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPOModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "purchaseOrderStopDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnOrderQty", "onOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.vendorOnOrderQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderUOM", "orderUom", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    return columns;
  };
  vendorOnOrderSummaryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "VendorCode#",
          "vendorCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "VendorName",
          "vendorName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalQuantity", "onOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
  
    return columns;
  };
  lastReceiptListColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "Fabric",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "Fabric Name",
          "fabricStyleName",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceiptDate", "purchaseReceiptDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PR#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewPRModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Ln#", "lineNumber", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Qty", "quantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM","uomCode", true,)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewPOModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("No.Rolls", "noOfRolls", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );

    return columns;
  };
  render() {
    let lastReceiptList = this.state.lastReceiptList;
    let is3PL = this.state.is3PL;
    let criteria = this.state.criteria;
    let inquiryData = this.state.inquiryData;
    let receiptList = this.state.receiptList;
    let orderInfoList = this.state.orderInfoList;
    let vendorSummaryDataList = this.state.vendorSummaryDataList;
    let fabricVendorInfoBean = this.state.fabricVendorInfoBean;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          {...this.state}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          vendorLookupHandler={this.state.vendorLookupHandler}
          lastReceiptDetails={this.lastReceiptDetails}
          vendorCodeOnChange={this.vendorCodeOnChange}
          vendorCodeRef={this.vendorCodeRef}
          vendorCodeEnterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
          displayAutoCompleteVendorList={this.displayAutoCompleteVendorList}
        />
        {this.state.isInquiryDatasFound && (
          <div>
            <div className="">
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel
                    className="hyperLinkText"
                    onClick={(e) =>
                      this.lastReceiptDetails(
                        e,
                        inquiryData.lastThreeMonthsPurchaseAmount,
                        3
                      )
                    }
                  >
                    Last3Months Receipts
                  </FormLabel>
                </Col>
                <Col className="summary_text_box" sm="2">
                  <NumberFormatInputbox
                    value={inquiryData.lastThreeMonthsPurchaseAmount}
                    className="summary_input text-right"
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel
                    className="hyperLinkText"
                    onClick={(e) =>
                      this.lastReceiptDetails(
                        e,
                        inquiryData.lastSixMonthsPurchaseAmount,
                        6
                      )
                    }
                  >
                    Last6Months Receipts
                  </FormLabel>
                </Col>
                <Col className="summary_text_box" sm="2">
                  <NumberFormatInputbox
                    value={inquiryData.lastSixMonthsPurchaseAmount}
                    className="summary_input text-right"
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel
                    className="hyperLinkText"
                    onClick={(e) =>
                      this.lastReceiptDetails(
                        e,
                        inquiryData.lastTwelveMonthsPurchaseAmount,
                        12
                      )
                    }
                  >
                    Last12Months Receipts
                  </FormLabel>
                </Col>
                <Col className="summary_text_box" sm="2">
                  <NumberFormatInputbox
                    value={inquiryData.lastTwelveMonthsPurchaseAmount}
                    className="summary_input text-right"
                    decimalScale={2}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel
                    className="hyperLinkText"
                    onClick={(e) =>
                      this.lastReceiptDetails(
                        e,
                        inquiryData.lastEighteenMonthsPurchaseAmount,
                        18
                      )
                    }
                  >
                    Last18Months Receipts
                  </FormLabel>
                </Col>
                <Col className="summary_text_box" sm="2">
                  <NumberFormatInputbox
                    value={inquiryData.lastEighteenMonthsPurchaseAmount}
                    className="summary_input text-right"
                    decimalScale={2}
                    disabled={true}
                  />
                </Col>
              </Row>
            </div>
            <div className="div_inline">
              <div className="div_Equal_no_height">
                <Row>
                  <FormLabel>Receipts Details</FormLabel>
                </Row>
                <br />
                <div className="mt-3">
                  <CustomTable
                    data={receiptList}
                    columns={this.inquiryColumns()}
                    enableVritualizer={true}
                  />
                </div>
              </div>
              <div className="div_Equal_no_height">
                <Row>
                  <FormLabel>OnOrder Details</FormLabel>
                </Row>
                <br />
                <div className="mt-3">
                  <CustomTable
                    data={orderInfoList}
                    columns={this.onOrderDetailsColumns()}
                    enableVritualizer={true}
                  />
                </div>
              </div>
            </div>
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowVendorSummaryPopup}
              closeOnEsc={false}
              popupLvlClass={"popupSizeLevel2"}
              closeAlertModalCallBack={this.closeAlertSummaryModalCallBack}
              title={"VendorOnOrder Summary Details"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              alertContainerBox={
                <AlertToolBox
                  alertMsgList={this.state.alertMessage}
                  alertErrorType={this.state.alertType}
                  isShowAlert={this.state.isShowAlert}
                  hideAlertCallBack={this.hideAlertCallBack}
                />
              }
              headerButtonContainer={
                <div className="floatLeft">
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateVendorSummaryPdf(e)}
                  >
                    PDF
                  </Button>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateVendorSummaryExcel(e)}
                  >
                    Excel
                  </Button>
                </div>
              }
              content={
                <div>
                  <Row>
                    <Col sm="1">
                      {is3PL ? (
                        <FormLabel>Item</FormLabel>
                      ) : (
                        <FormLabel>FabricStyle</FormLabel>
                      )}
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="fabricStyleCode"
                        type="text"
                        value={fabricVendorInfoBean.fabricStyleCode}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="fabricStyleName"
                        type="text"
                        value={fabricVendorInfoBean.fabricStyleShortName}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>ColorCode</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="fabricStyleColorCode"
                        type="text"
                        value={fabricVendorInfoBean.colorCode}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <div className="mt-3">
                    <CustomTable
                      data={vendorSummaryDataList}
                      columns={this.vendorOnOrderSummaryColumns()}
                      enableVritualizer={true}
                    />
                  </div>
                </div>
              }
            />
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowVendorQtyPopup}
              closeOnEsc={false}
              popupLvlClass={"popupSizeLevel1"}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              title={"VendorOnOrderDetails"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              alertContainerBox={
                <AlertToolBox
                  alertMsgList={this.state.alertMessage}
                  alertErrorType={this.state.alertType}
                  isShowAlert={this.state.isShowAlert}
                  hideAlertCallBack={this.hideAlertCallBack}
                />
              }
              headerButtonContainer={
                <div className="floatLeft">
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateVendorOnOrderPdf(e)}
                  >
                    PDF
                  </Button>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.generateVendorOnOrderExcel(e)}
                  >
                    Excel
                  </Button>
                  <Button
                    className="header_buttons enterFocus"
                    size="sm"
                    onClick={(e) => this.vendorSummaryOnClick(e)}
                  >
                    Summary
                  </Button>
                </div>
              }
              content={
                <div>
                  <VendorOnOrderDetailsForm
                    {...this.state}
                    fabricVendorInfoBean={this.state.fabricVendorInfoBean}
                    vendorQtyDataList={this.state.vendorQtyDataList}
                  />
                </div>
              }
            />
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowLastReceiptDetailsPopup}
              popupLvlClass={"popupSizeLevel0"}
              closeOnEsc={false}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              title={"Last Receipt Details"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              content={
                <div className="">
                  <Row>
                    <Col sm="1">
                      <FormLabel>VendorCode</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={criteria.vendorCode}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <div className="mt-3">
                    <CustomTable
                      data={lastReceiptList}
                      columns={this.lastReceiptListColumns()}
                      enableVritualizer={true}
                    />
                  </div>
                </div>
              }
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
class VendorOnOrderDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowVendorModule: false,
      isShowPurchaseOrderModule: false,
      modulePopup: [],
    };
  }
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowSalesModule: isOpen,
      isShowVendorModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      moduleForPopup: [],
    });
  };
  vendorOnOrderColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Vendor#",
          "vendorCode",
          true
        )
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewVendorModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "VendorName",
          "vendorName",
          true
        )
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPoModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderDate", "purchaseOrderStartDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Cust#",
          "reserveCustomerCode",
          true
        )
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Name",
          "reserveCustomerName",
          true
        )
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Type", "orderType", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("DueDate", "purchaseOrderDueDate", true, true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  salesOrderDetailColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          " SO#",
          "salesOrderNumber",
          true
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewSalesModule, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Customer",
          "customerCode",
          true
        )
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "CustomerName",
          "customerName",
          true
        )
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer PO#", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(" Start Date", "orderStartDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(" Stop Date", "orderStopDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Order Oty", "orderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );

    return columns;
  };
  render() {
    let fabricVendorInfoData = this.props.fabricVendorInfoBean;
    let vendorQtyDataList = this.props.vendorQtyDataList;
    let sourceOrderDetailLines = this.props.sourceOrderDetailLines;
    return (
      <div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <Row>
          {this.props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
          <Col sm="2">
            <InputTextbox
              name="fabricStyleCode"
              type="text"
              value={fabricVendorInfoData.fabricStyleCode}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleName"
              type="text"
              value={fabricVendorInfoData.fabricStyleShortName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>ColorCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleColorCode"
              type="text"
              value={fabricVendorInfoData.colorCode}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>InTransit</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="inTransitQuantity"
              type="text"
              value={fabricVendorInfoData.inTransitQuantity}
              disabled={true}
              className="text-right"
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>VendorQty</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              value={fabricVendorInfoData.onOrderQuantity}
              className="qty_input text-right"
              decimalScale={2}
              name={"vendorOnOrderQuantity"}
              disabled={true}
            />
          </Col>
        </Row>{" "}
        <div className="div_inline">
          <div className="div_Equal_no_height">
            <div className="mt-3">
              <CustomTable
                data={vendorQtyDataList}
                columns={this.vendorOnOrderColumns()}
                enableVritualizer={true}
              />
            </div>
          </div>
          <div className="div_Equal_no_height">
            <div className="mt-3">
              <CustomTable
                data={sourceOrderDetailLines}
                columns={this.salesOrderDetailColumns()}
                enableVritualizer={true}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  let criteria = props.criteria;
  let isDisableFields = props.isDisableFields;
  const vendorCodeOnChange = (e) => props.vendorCodeOnChange(e);
  let vendorLookupHandler = props.vendorLookupHandler;
  const vendorCodeRef = props.vendorCodeRef;
  let isInquiryDatasFound = props.isInquiryDatasFound;
  let inquiryData = props.inquiryData;
  const lastReceiptDetails = (e) => {
    if (e.detail === 1) {
      props.lastReceiptDetails(
        e,
        inquiryData.lastTwentyFourMonthsPurchaseAmount,
        24
      );
    }
  };
  const vendorCodeEnterKeyEventHandler = (e) => {
    props.vendorCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteVendorList = () => {
    props.displayAutoCompleteVendorList();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>VendorCode</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={vendorCodeRef}
            name="vendorCode"
            placeholder="vendor"
            onChange={vendorCodeOnChange}
            value={criteria.vendorCode}
            lookupRequired={true}
            lookupHandler={vendorLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={vendorCodeEnterKeyEventHandler}
            autoCompleteListData={props.vendorPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteVendorList}
            showAutoCompleteList={props.showAutoCompleteVendorList}
            disabled={isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>VendorName</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="vendorName"
            onChange={onChange}
            value={criteria.vendorName}
            disabled={true}
          />
        </Col>
        {isInquiryDatasFound && (
          <Col sm="1">
            <FormLabel> Purchase Summary </FormLabel>
          </Col>
        )}
        {isInquiryDatasFound && (
          <Col sm="1">
            <FormLabel
              className="hyperLinkText"
              onClick={(e) =>
                lastReceiptDetails(
                  e,
                  inquiryData.lastTwentyFourMonthsPurchaseAmount,
                  24
                )
              }
            >
              Last24MonthReceipts
            </FormLabel>
          </Col>
        )}
        {isInquiryDatasFound && (
          <Col sm="2">
            <NumberFormatInputbox
              value={inquiryData.lastTwentyFourMonthsPurchaseAmount}
              className="summary_input text-right"
              decimalScale={2}
              disabled={true}
            />
          </Col>
        )}
      </Row>
    </div>
  );
}
function VendorStatisticsInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <VendorStatistics {...props} name="" /> <br />
    </div>
  );
}

export default VendorStatisticsInquiry;
